import { useLocale } from '@ecomm/data-hooks'
import { useMemo, useState } from 'react'

import { useHideUntilMounted } from '@ecomm/shared-hooks'
import { usePhoneAndMonitoringInNavExperience } from '@ecomm/shared-ninetailed-phone'
import { NavLink } from './NavLink'
import { NavMenu } from './NavMenu'
import { getMainMenuItems } from './data'
import type { HeaderRedesignSchema } from './schema'

export function MainNav(props: HeaderRedesignSchema) {
  const { status, isVariant: isPhoneVariant } =
    usePhoneAndMonitoringInNavExperience()
  const locale = useLocale()

  const [activeDropdownIndex, setActiveDropdownIndex] = useState(-1)

  /**
   * TODO: remove this after `All | US | Nav | Monitoring and Phone` is done.
   */
  const classes = useHideUntilMounted('MainNav')

  const menuItems = useMemo(() => {
    return getMainMenuItems(locale, isPhoneVariant, status)
  }, [isPhoneVariant, locale, status])

  return (
    <div className="hidden h-full items-center justify-between gap-6 justify-self-start text-lg min-[1126px]:flex min-[1185px]:gap-10">
      {menuItems.map((item, i) =>
        item.hasDropdown ? (
          <NavMenu
            // 2 and 3 are "take our quiz" and "services" which both flicker in
            className={[2, 3].includes(i) ? classes : ''}
            dropdownMenu={item.dropdownMenu}
            key={item.text}
            mainNavDesktop={true}
            onToggleDropdown={(close?: boolean) =>
              setActiveDropdownIndex(
                close ? -1 : activeDropdownIndex === i ? -1 : i
              )
            }
            showDropdown={activeDropdownIndex === i}
            text={item.text}
            {...props}
          />
        ) : (
          <NavLink
            className={[2, 3].includes(i) ? classes : ''}
            key={item.text}
            openQuiz={item.openQuiz}
            quoteWizard={{ ...props.quoteWizard }}
            text={item.text}
            url={item.url}
          />
        )
      )}
    </div>
  )
}
